import { Link } from "react-router-dom";
import { allVideos } from "@/lib/videoData";

const topVideos = [...allVideos].sort((a, b) => b.heat - a.heat).slice(0, 6);

export default function RankingList() {
  return (
    <aside className="rounded-lg border border-background-200/90 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-line text-lg text-accent-600" />
          全站热播榜
        </h2>
        <span className="rounded bg-accent-100 px-2 py-0.5 text-[10px] font-semibold text-accent-800">实时</span>
      </div>
      <p className="mt-1 text-[11px] text-foreground-500">按近 7 天播放热度排序</p>

      <ul className="mt-4 space-y-1">
        {topVideos.map((video, index) => (
          <li key={video.id}>
            <Link
              to={`/detail/${video.id}`}
              className="group flex cursor-pointer items-center gap-3 rounded-md px-1.5 py-2 transition-colors hover:bg-background-100"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded font-heading text-xs font-extrabold ${
                  index < 3 ? "bg-primary-800 text-accent-300" : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </span>
              <div className="min-w-0 flex-1">
                <p className="line-clamp-1 text-[13px] font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
                  {video.title}
                </p>
                <p className="mt-0.5 line-clamp-1 text-[11px] text-foreground-500">
                  {video.genre.join(" / ")} · {video.year}
                </p>
              </div>
              <div className="shrink-0 text-right">
                <p className="flex items-center gap-0.5 text-[11px] font-bold text-accent-700">
                  <i className="ri-star-fill text-[9px]" />
                  {video.rating.toFixed(1)}
                </p>
                <p className="mt-0.5 text-[10px] text-foreground-400">{(video.heat / 10000).toFixed(1)} 万</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>

      <div className="mt-4 rounded-md bg-primary-950 p-3.5">
        <p className="text-[11px] font-semibold text-accent-300">片库每日更新</p>
        <p className="mt-1 text-[11px] leading-relaxed text-background-300">
          收录 30 部精选影视综艺，筛选、排序与收藏功能均已开放体验。
        </p>
        <Link
          to="/category/movie"
          className="mt-3 flex h-8 items-center justify-center gap-1 rounded bg-accent-500 text-[11px] font-bold whitespace-nowrap text-foreground-950 transition-colors hover:bg-accent-400"
        >
          去片库逛逛
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      </div>
    </aside>
  );
}